var React = require('react');

function IconMore (props) {
    return React.createElement("svg",props,React.createElement("path",{"fill":"#9e9e9e","d":"M13 10a3 3 0 1 0-3-3 3.009 3.009 0 0 0 3 3zm0 3a3 3 0 1 0 3 3 3.009 3.009 0 0 0-3-3zm0 9a3 3 0 1 0 3 3 3.009 3.009 0 0 0-3-3z","transform":"translate(-10 -4)"}));
}

IconMore.defaultProps = {"width":"6","height":"24","viewBox":"0 0 6 24"};

module.exports = IconMore;

IconMore.default = IconMore;
